export default {
  recentlyViewed: {
    emptyTitleFiltered: 'No matches',
    emptyHintFiltered: 'No shared work matches your search.',
    tab: 'Shared with me',
    remove: 'Remove from Shared with me',
    emptyTitle: 'Nothing here yet',
    emptyHint:
      'Work other people share with you shows up here once you open it.',
  },
  betaBadge: {
    label: 'Beta',
  },
  controls: {
    sortAriaLabel: 'Sort',
    sortAscTooltip: 'Ascending — click for descending',
    sortDescTooltip: 'Descending — click for ascending',
    sortAscAriaLabel: 'Sorted ascending, switch to descending',
    sortDescAriaLabel: 'Sorted descending, switch to ascending',
    gridViewAriaLabel: 'Grid view',
    listViewAriaLabel: 'List view',
  },
  loadMore: {
    loading: 'Loading…',
  },
  uploadZone: {
    rejectTooLarge: 'File is too large. Maximum size is {{maxGb}} GB.',
    rejectInvalidType: 'Invalid file type. Only {{types}} files are accepted.',
    rejectGeneric: 'File could not be uploaded.',
    uploading: 'Uploading…',
    repairTooltip:
      'Diagnoses and repairs the CAD before meshing — fixes gaps, non-manifold edges, and bad faces. The default.',
    wrapTooltip:
      'Wraps the part in a clean watertight surface, then meshes that instead — more robust on dirty or leaky CAD. Best for checking whether a part meshes at all; per-face boundary tags are not carried through yet. Handles external flow, internal flow and conjugate heat transfer, and is fixed once imported — pick Repair if you need FEA, or need to name individual bodies.',
    repair: 'Repair',
    wrap: 'Wrap',
    browseFiles: 'Browse files',
    fileInputLabel: 'Choose a CAD file to upload',
  },
  uploadPrep: {
    title: 'Choose geometry prep',
    description:
      'How should {{file}} be prepared before meshing? This is fixed once imported.',
    cancel: 'Cancel',
    confirm: 'Import',
  },
  aiActivity: {
    tab: 'AI activity',
    chipNeedsYou_one: 'Needs you',
    chipNeedsYou_other: '{{count}} need you',
    chipNeedsYouHint_one:
      'The AI has a fix ready and is waiting for you to say yes.',
    chipNeedsYouHint_other:
      'The AI has {{count}} fixes ready and is waiting for you to say yes.',
    chipRetrying_one: 'AI retrying',
    chipRetrying_other: '{{count}} retrying',
    chipRetryingHint_one:
      'Something failed, so the AI changed the settings and is running it again.',
    chipRetryingHint_other:
      'The AI is running {{count}} of these again with changed settings.',
    chipFixed_one: '1 fixed',
    chipFixed_other: '{{count}} fixed',
    chipFixedHint_one: 'The AI got this one working after it failed.',
    chipFixedHint_other:
      'The AI got {{count}} of these working after they failed.',
    filterContext_one:
      'Showing 1 of {{total}} — the AI has been working on this',
    filterContext_other:
      'Showing {{count}} of {{total}} — the AI has been working on these',
    filterEmptyTitle: 'The AI has nothing for you',
    filterEmptyHint:
      'Nothing here needs your call, and the AI has not fixed anything in the last {{days}} days.',
    clearFilter: 'Clear filter',
    columnHeader: 'AI',
  },
} as const;
